import {ROUTES} from '../../../config/index.js'
import {MAX_NUM_OF_ADS} from './settings.js'

export const getInitialProps = async ({routeInfo, context: {i18n, domain, pde}}) => {
  const {
    location: {pathname: path},
    params: {
      make: makeUrlParam,
      model: modelUrlParam,
      bodyType: bodyTypeUrlParam,
      doors: doorsUrlParam,
      version: versionUrlParam,
      versionId,
      vehicleId
    }
  } = routeInfo

  const {culture} = i18n

  const config = domain.get('config')
  const {DEFAULT_SEARCH, OFFER_TYPE_NEW, HAS_NEW_VEHICLE_ADS_LIST_ENABLED} = config.get('search')

  const {HAS_JATO: hasJato} = config.get('vehicles')

  const {HAS_VEHICLE_INFO_COMPETITORS: hasVehicleInfoCompetitors} = config.get('technicalDetails')

  const serverErrors = []

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

  const initialTechnicalDetailsInfoFactory = async () => {
    const getVehicleInfo = async () => {
      const [error, response] = await domain.get('get_vehicle_info_vehicles_use_case').execute({
        pageName,
        competitors: hasVehicleInfoCompetitors,
        grouped: true,
        make: makeUrlParam,
        model: modelUrlParam,
        vehicleId
      })

      if (error) return serverErrors.push(error)
      return response
    }

    const initialpageInfoResponse = await getVehicleInfo()

    const {vehicleInfo: pageInfoResponse} = initialpageInfoResponse || {}

    const {
      initMarketedDate,
      specifications: {fuelType, version: specificVersionName} = {},
      groupedSpecifications: {engine: {fuelType: groupedFuelType} = {}, body: {version: groupedVersionName} = {}} = {},
      year,
      makeId,
      modelId
    } = pageInfoResponse || {}

    const _getTotalResultsForNewVehicle = async () => {
      const search = {
        ...DEFAULT_SEARCH,
        offerTypeId: OFFER_TYPE_NEW,
        makeId,
        model: {id: modelId}
      }
      return domain.get('get_total_results_ads_use_case').execute(search)
    }

    const versionName = specificVersionName || groupedVersionName

    const hasFuelType = fuelType || groupedFuelType

    const searchObject = {
      ...DEFAULT_SEARCH,
      offerTypeId: OFFER_TYPE_NEW,
      makeId,
      model: {id: modelId}
    }

    const [
      [seoDataError, seoDataResponse],
      tagclouds,
      [, breadcrumbs],
      [getModelDetailAdsUseCaseError, getModelDetailAdsUseCaseResult],
      [getModelImageError, getModelImageResponse]
    ] = await Promise.all([
      domain.get('get_seo_data_use_case').execute({
        culture,
        pageName,
        params: {
          make: makeUrlParam,
          model: modelUrlParam,
          ...(bodyTypeUrlParam && {bodyType: bodyTypeUrlParam}), // TODO: check how to get bodyTypeIds MTR-56077
          ...(doorsUrlParam && {doors: doorsUrlParam}),
          ...(hasFuelType && {fuelType: fuelType || groupedFuelType}),
          ...(initMarketedDate && {initDate: initMarketedDate}),
          ...(vehicleId && {vehicleId}),
          ...(versionId && {versionId}),
          ...(versionName && {version: versionName}),
          ...(year && {year})
        }
      }),
      domain.get('get_tagcloud_seo_use_case').execute({
        pageName,
        makeId: pageInfoResponse?.makeId,
        modelId: pageInfoResponse?.modelId
      }),
      domain.get('get_breadcrumbs_breadcrumb_use_case').execute({
        pageName,
        params: {
          section: makeUrlParam,
          model: modelUrlParam,
          ...(versionName && {version: versionName})
        }
      }),
      domain.get('get_model_detail_relevant_ads_use_case').execute(searchObject),
      domain.get('get_model_image_vehicles_use_case').execute({
        makeId,
        modelId
      })
    ])

    let totalResults = 0
    let hasNewVehicles = false
    if (HAS_NEW_VEHICLE_ADS_LIST_ENABLED) {
      const [, totalResultsResponse] = await _getTotalResultsForNewVehicle()
      totalResults = totalResultsResponse.totalResults
      hasNewVehicles = totalResults > 0
    }

    let modelDetailAdsNew
    let modelDetailAdsKm0
    let modelDetailAdsRenting
    let bestOffers
    if (!getModelDetailAdsUseCaseError) {
      const {newVehicles, km0Vehicles, rentingVehicles} = getModelDetailAdsUseCaseResult
      modelDetailAdsNew = newVehicles?.items
      modelDetailAdsKm0 = km0Vehicles?.items
      modelDetailAdsRenting = rentingVehicles?.items
      bestOffers = [newVehicles?.highlightedAd, rentingVehicles?.highlightedAd].filter(Boolean).map(ad => {
        return {
          ...ad,
          make: {name: pageInfoResponse.make, id: makeId},
          model: {name: pageInfoResponse.model, id: modelId}
        }
      })
    }

    const seoData = seoDataResponse || {}

    const {
      TECHNICAL_DETAILS: {VERSION: versionRoute, MAKE: makeRoute}
    } = ROUTES

    const hasAllParams = modelUrlParam && bodyTypeUrlParam && doorsUrlParam && versionUrlParam

    const urlToRedirect = hasAllParams
      ? `${versionRoute
          .replace(':make', makeUrlParam)
          .replace(':model', modelUrlParam)
          .replace(':bodyType', bodyTypeUrlParam)
          .replace(':doors', doorsUrlParam)
          .replace(':version', versionUrlParam)
          .replace(':versionId', versionId)}/`
      : `${makeRoute.replace(':make', makeUrlParam)}/`

    const hasCriticalServerErrors = Boolean(serverErrors.length)

    const getBasicDataSheet = () => {
      if (!pageInfoResponse) return null
      const {groupedSpecifications = {}} = pageInfoResponse
      const {body = {}, consumption = {}, engine = {}} = groupedSpecifications
      const {fuelType, hp, transmissionType} = engine
      const {consumptionAverage, topSpeed, acceleration, traction} = consumption
      const {luggageCapacity, bodyType} = body
      return {
        ...(fuelType && {fuelType}),
        ...(consumptionAverage && {consumptionAverage}),
        ...(luggageCapacity && {luggageCapacity}),
        ...(topSpeed && {topSpeed}),
        ...(hp && {hp}),
        ...(bodyType && {bodyType}),
        ...(acceleration && {acceleration}),
        ...(traction && {traction}),
        ...(transmissionType && {transmissionType})
      }
    }
    const basicDataSheet = getBasicDataSheet()

    const photos = pageInfoResponse?.images?.map(({src}) => src)

    let dimensionsImage
    if (getModelImageResponse) {
      dimensionsImage = getModelImageResponse.src
    }
    return {
      ...(hasCriticalServerErrors && {__HTTP__: {redirectTo: urlToRedirect}}),
      adsKm0: modelDetailAdsKm0?.slice(0, MAX_NUM_OF_ADS),
      adsNew: modelDetailAdsNew?.slice(0, MAX_NUM_OF_ADS),
      adsRenting: modelDetailAdsRenting?.slice(0, MAX_NUM_OF_ADS),
      basicDataSheet,
      bestOffers,
      bodyType: bodyTypeUrlParam,
      breadcrumbs,
      dimensionsImage,
      doors: doorsUrlParam,
      fuelType: fuelType || groupedFuelType,
      hasJato,
      hasNewVehicles,
      helmet: seoData.head,
      makeId: pageInfoResponse?.makeId,
      makeName: pageInfoResponse?.make,
      makeUrlParam,
      modelId: pageInfoResponse?.modelId,
      modelName: pageInfoResponse?.model,
      modelUrlParam,
      pageErrors: {
        seoDataError,
        getModelImageError
      },
      pageName,
      photos,
      tagclouds,
      vehicleId,
      ...(versionId && {versionId}),
      versionName,
      year: pageInfoResponse?.year,
      ...(pageInfoResponse && {pageInfoResponse}),
      ...(Boolean(serverErrors.length) && {serverErrors})
    }
  }

  const initialTechnicalDetailsInfo = await initialTechnicalDetailsInfoFactory()

  return initialTechnicalDetailsInfo
}
